<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-6"
        :placeholder="$t('name')"
        :label="$t('name')"
        help="Este es el nombre del Widget con el que se mostrará en los listados"
        :v="$v.value.name"
        v-model="value.name"
      />
      <LmTextInput
        class="col-6"
        :placeholder="$t('title')"
        :label="$t('title')"
        help="Este es el título del Widget"
        :v="$v.value.title"
        v-model="value.title"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_in')"
        type="multiple"
        :options="availableInOptions"
        v-model="value.availableIn"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'

export default {
  components: {
    LmTextInput,
    LmCheckbox
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      availableInOptions: [
        {
          text: 'Bandeja de Entradas',
          value: 'inbox'
        },
        {
          text: 'Dashboard',
          value: 'dashboard'
        }
      ],
      dataOriginOptions: [],
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ]
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      title: {
        required
      }
    }
  }
}
</script>
